import React from "react";
import { Layout, Typography, Breadcrumb, Row, Col, Card } from "antd";
import { Link } from "react-router-dom";
import Headerdiv from "../layout/header.js";
import Footerdiv from "../layout/footer.js";
import { APPBACKGROUND_COLOR } from "../appsettings.js";

const { Content } = Layout;
const { Title, Text } = Typography;

const Reports = () => {

    const reportCategories = [
        {
            title: "Stocks Reports",
            links: [
                { label: "Live Stock", path: "/reports/stock/stock-liveupdate-report" },
                {label: "Stock Analysis", path: "/reports/stock/stock-analysis-report" },
                {label: "Stock Item Movement Report", path: "/reports/stock/stock-item-movement-report"}
            ],
        },
        {
            title: "Sales Reports",
            links: [
                { label: "Daily Sale Report", path: "/reports/sale/daily-sale-report" },
                {label: "Daily Sale Report(Chart)", path: "/reports/sale/daily-sale-report-chart" },
                {label: "Month End Sale Summary", path: "/reports/sale/month-end-sale-summary" }
            ]
        },
        {
            title: "Tellers Reports",
            links: [
                { label: "Teller Transaction Summary", path: "/reports/teller/teller-transaction-summery" },
            ]
        },
        {
            title:"MLM Users Reports",
            links: [
                { label: "MLM User List Details Report", path: "/reports/mlm/mlm-user-report" },
                {label: "MLM User Monthly Performance Report", path: "/reports/mlm/montly-performance-report" },
                {label: "MLM User Monthly Performance Report By Consultant", path: "/report/mlm/monthly-performance-report-by-consultant"}
            ]
        }
    ];

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: "100vh" }}>
            <Headerdiv />

            <Content style={{ padding: "16px 24px" }}>
                {/* Breadcrumbs */}
                <Breadcrumb style={{ marginBottom: 16 }}>
                    <Breadcrumb.Item>Reports</Breadcrumb.Item>
                    <Breadcrumb.Item>ERP Reports</Breadcrumb.Item>
                </Breadcrumb>

                {/* Page Title */}
                <Title level={4}>ERP Reports</Title>

                {/* Report Cards */}
                {reportCategories.map((category) => (
                    <Card
                        key={category.title}
                        title={<Text strong>{category.title}</Text>}
                        bordered
                        style={{ borderRadius: 8, marginBottom: 24 }}
                    >
                        <Row gutter={[16, 16]}>
                            {category.links.map((link, index) => (
                                <Col key={index} xs={24} sm={12}>
                                    <ul style={{ paddingLeft: 20, margin: 0 }}>
                                        <li><Link to={link.path}>{link.label}</Link></li>
                                    </ul>
                                </Col>
                            ))}
                        </Row>
                    </Card>
                ))}
            </Content>

            <Footerdiv />
        </Layout>
    );
};

export default Reports;
